/**
 * returns typeform share URl from typeform Id
 *
 * @param {String} typeformId - Typeform ID
 */

export function getTypeformURL(typeformId) {
  return `https://madamcurious.typeform.com/to/${typeformId}`;
}
